import useMusioApi from "@/contexts/client/musio-client-context";
import { LicenseRow } from "./license-redemption/license-row";
import { LicenseDialog } from "./license-redemption/license-dialog";
import { LoadingIndicator } from "@/components/ui/loading-indicator";
import { NotificationRow } from "@/components/ui/notification-row";

export const Licenses = () => {
  const { musioApi } = useMusioApi();
  const { data, isPending, isError } = musioApi.useQuery("get", "/user/licenses");

  return (
    <div className="px-7 py-2 w-full">

      <div className="pt-7 pb-3 flex flex-row justify-between">
        <div>
          <h2 className="text-xl font-bold text-white">Licenses</h2>
          <p className="text-sm text-musio-text-light">Redeem and manage your product licenses</p>
        </div>
        <LicenseDialog />
      </div>

      {isError ?
        <NotificationRow intent={"error"}>
          Error retrieving your license data
        </NotificationRow> : null
      }

      <div className="w-full py-1 flex flex-col space-x-5">

        <div className="w-full ">
          <h3 className="text-sm font-normal text-lilac">Timed Licenses</h3>
          <div className="p-2 flex flex-col space-y-1 w-full">
            {isPending ? <LoadingIndicator /> : data?.timed.map((license, index) => (<LicenseRow {...license} key={index} />))}
          </div>
        </div>

        <div className="w-full">
          <h3 className="text-sm font-normal text-lilac">Perpetual Licenses</h3>
          <div className="p-2 flex flex-col space-y-1 w-full">
            {isPending ? <LoadingIndicator /> : data?.perpetual.map((license, index) => (<LicenseRow {...license} key={index} />))}
          </div>
        </div>

      </div>
    </div>
  );

};
